export default class LocalStorage {
  static saveToLocalStorage(data, id) {
    try {
      window.localStorage.setItem(id, JSON.stringify(data));
    } catch (err) {
      throw new Error(err);
    }
  }

  static loadFromLocalStorage(id) {
    try {
      const data = JSON.parse(window.localStorage.getItem(id));
      if (data === null) {
        return undefined;
      }
      return data;
    } catch (err) {
      throw new Error(err);
    }
  }

  static removeFromLocalStorage(id) {
    try {
      return window.localStorage.removeItem(id);
    } catch (err) {
      throw new Error(err);
    }
  }
}
